import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '../Pagination';
import axios from '../../api/api';
import { Link } from 'react-router-dom';
import { MdOutlineBlock } from 'react-icons/md';
import { FaRegEye } from "react-icons/fa";
import Loader from '../Loader';

const Clients = () => {

  const [client, setClient] = useState([]);
  const [searchClientEmail, setSearchClientEmail] = useState('');
  const [searchClientCompany, setSearchClientCompany] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [count, setCount] = useState(0)
  const [total, setTotal] = useState(0)

  // Fetch All clients
  const getClients = useCallback(async (offset, limit, email, company_name) => {
    try {
      let query = `?offset=${offset}&limit=${limit}`

      if (email) {
        query += `&email=${email}`
      }

      if (company_name) {
        query += `&company_name=${company_name}`
      }

      const response = await axios.get(`/clients/${query}`);
      setClient(response.data.items);
      setCount(response.data.count)
      setTotal(response.data.total)
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error.response) {
        setError("Network error! Check your connection.");
      } else if (error.response.status) {
        setError(error.response.data.detail)
      } else if (error.response.status >= 500) {
        setError("Server error! Please try again later.");
      } else {
        setError("An unexpected error occurred!");
      }
    }
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setLoading(true);
      getClients((currentPage - 1) * recordsPerPage, recordsPerPage, searchClientEmail, searchClientCompany);
    }, 1000);
    return () => clearTimeout(timerId);
  }, [currentPage, recordsPerPage, searchClientEmail, searchClientCompany, getClients]);


  // search client by email
  const handleSearchChange = (e) => {
    setSearchClientEmail(e.target.value);
    setCurrentPage(1);
  };

  // search client by company name
  const handleCompanySearchChange = (e) => {
    setSearchClientCompany(e.target.value);
    setCurrentPage(1);
  };


  return (
    <div className='mx-auto p-4'>
      <div className="bg-white rounded-lg p-4 w-full flex-1 min-w-0">
        <div className='flex flex-wrap items-center justify-between py-3'>
          <Link to='/addclient' className='bg-[#134463] hover:bg-[#165277] text-white px-5 py-1.5 rounded-lg'>Add Client</Link>
          <h5 className='text-[#165277] font-bold'>Showing {count} / {total} Clients</h5>
          <div className='py-2 flex flex-wrap gap-2'>
            <label htmlFor='search'><span className='hidden'>Search</span>
              <input
                type='search'
                id='search'
                className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                required
                placeholder='Search company name'
                value={searchClientCompany}
                onChange={handleCompanySearchChange}
              />
            </label>
            <label htmlFor='search'><span className='hidden'>Search</span>
              <input
                type='search'
                id='search'
                className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                required
                placeholder='Search client email'
                value={searchClientEmail}
                onChange={handleSearchChange}
              />
            </label>
          </div>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#e9f3f9] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#e9f3f9] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          <div className='overflow-x-auto rounded-lg'>
            {client.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>No</th>
                      <th className='p-2'>Company Name</th>
                      <th className='p-2'>User Name</th>
                      <th className='p-2'>First Name</th>
                      <th className='p-2'>Last Name</th>
                      <th className='p-2'>Email</th>
                      <th className='p-2'>Phone</th>
                      <th className='p-2'>Address</th>
                      <th className='p-2'>City</th>
                      <th className='p-2'>Created At</th>
                      <th className='p-2'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {client.map((clients) => (
                      <tr key={clients.id}>
                        <td className='p-2 '>{clients.id}</td>
                        <td className='p-2'>{clients.company_name}</td>
                        <td className='p-2'>{clients.user_name}</td>
                        <td className='p-2'>{clients.first_name}</td>
                        <td className='p-2'>{clients.last_name}</td>
                        <td className='p-2'>{clients.email_address}</td>
                        <td className='p-2'>{clients.phone_number}</td>
                        <td className='p-2'>{clients.address}</td>
                        <td className='p-2'>{clients.city}</td>
                        <td className='p-2'>{new Date(clients.created_at).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2'><Link to={`/client/${clients.id}`}><button className='bg-green-200 text-green-700 p-1 text-xl rounded-lg'><FaRegEye /></button></Link></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#e9f3f9] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
        )}
        <div className='flex flex-wrap items-center justify-between mt-4 gap-4'>
          <div>
            <span className='mr-2'>Records per page:</span>
            <select
              className='px-3 py-1 border bg-[#e9f3f9] border-slate-300 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(parseInt(e.target.value, 10));
                setCurrentPage(1);
              }}
            >
              <option value='20'>20</option>
              <option value='50'>50</option>
              <option value='75'>75</option>
              <option value='100'>100</option>
            </select>
          </div>
          <Pagination
            nPages={Math.ceil(total / recordsPerPage)}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </div>
  );
};

export default Clients;
